import EventsKeywordFilter from './EventsKeywordFilter';
import PrimaryViewToggle from './PrimaryViewToggle';
import announce from '../../utils/screen-reader/announce';
import ScreenReaderLoadingMessages from '../../utils/screen-reader/ScreenReaderLoadingMessages';
import EventsListingPageComponent from './EventsListingPageComponent';

const Messaging = window.tnew.ui.messaging;

const dateLoadedToken = '{:DateLoaded}';

/** @typedef {import('./api/DataStore').default} DataStore */

class EventListingPrimaryView {
  /**
   * @param {*} config
   * @param {EventsKeywordFilter} keywordFilter
   * @param {PrimaryViewToggle} viewToggle
   * @param {DataStore} store
   */
  constructor(config, keywordFilter, viewToggle, store) {
    this.keywordFilter = keywordFilter;
    this.config = config;
    this.isVisible = false;
    this.viewToggle = viewToggle;
    this.store = store;

    this.keywordFilter.on(EventsKeywordFilter.UPDATE, this.onKeywordFilterUpdate.bind(this));

    this.viewToggle.on(PrimaryViewToggle.UPDATE, this.onPrimaryViewModeUpdate.bind(this));

    this.store.on('fetchStart', () => {
      announce(EventsListingPageComponent.screenReaderProcessingRequestMessage);
    });
  }

  onPrimaryViewModeUpdate({ mode }) {
    this.isVisible = this.constructor.ViewMode === mode;

    if (this.isVisible) {
      this.fetchData();
    }
  }

  onKeywordFilterUpdate() {
    if (this.isVisible) {
      this.fetchData();
    }
  }

  getSelectedDateFormatted() {
    return this.getCurrentView().getSelectedDateFormatted();
  }

  async fetchData() {
    const view = this.getCurrentView();
    const keywords = this.keywordFilter.getSelectedKeywords();
    const messageCategory = 'event-listing';
    let data;

    Messaging.clear(messageCategory);

    try {
      data = await this.store.fetchData(view.getRangeForSelectedDate(), keywords);
    } catch (exception) {
      Messaging.clear(messageCategory);
      Messaging.addError('An unexpected error has occurred.', true, messageCategory);
      announce(ScreenReaderLoadingMessages.Fail);
      return;
    }

    if (data) {
      view.setData(data);
      const completeMessage = EventsListingPageComponent.screenReaderProcessingRequestCompleteMessage
        .replace(dateLoadedToken, view.getSelectedDateFormatted());
      announce(completeMessage);
    } else {
      // console.warn('fetch result ignored');
    }
  }
}

export default EventListingPrimaryView;
